module.exports = __webpack_public_path__ + "static/media/gal-8.f30fbda6.jpeg";